// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 22V2H22V22H2ZM8.5 12L14 16.25V7.75L8.5 12Z"}}]};

const ChevronLeftRectangleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-left-rectangle-filled',
    ref,
    icon: element,
  },
));

ChevronLeftRectangleFilledIcon.displayName = 'ChevronLeftRectangleFilledIcon';

export default ChevronLeftRectangleFilledIcon;
